import React from "react";

const About = () => <div>About us page</div>;

export default About;
